import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import { scrollToBookingForm } from "commonUtils/misc";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "relative",
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(2),
    textAlign: "center",
    "&::after": {
      content: "''",
      width: "100%",
      height: "1px",
      background: "#E2E8F1",
      position: "absolute",
      top: "50%",
      left: 0,
      zIndex: 0,
    },
  },
  label: {
    textTransform: "uppercase",
    color: "oklch(55.4% .046 257.417)",
    fontWeight: 500,
    fontSize: "0.75rem",
    background: "#fff",
    position: "relative",
    zIndex: 1,
    padding: "0 10px",
  },
  inlineLink: {
    padding: 0,
    border: "none",
    background: "none",
    font: "inherit",
    cursor: "pointer",
    color: "var(--gc-action-strong)",
    fontWeight: 700,
    textDecoration: "underline",
    textUnderlineOffset: "2px",
    borderRadius: "2px",
    "&:hover": {
      color: "var(--gc-action-hover)",
    },
    "&:focus-visible": {
      outline: "2px solid var(--gc-action)",
      outlineOffset: "2px",
    },
  },
}));

export default function MembershipFooter({ source }) {
  const classes = useStyles();

  const introText =
    source === "main"
      ? "Oppure se non sei registrato prosegui compilando il form e "
      : "Oppure prosegui senza registrazione e ";

  return (
    <div className={classes.root}>
      <Typography component="span" variant="body2" className={classes.label}>
        {introText}
        <button
          type="button"
          className={classes.inlineLink}
          onClick={scrollToBookingForm}
        >
          registrati &darr;
        </button>
      </Typography>
    </div>
  );
}
